import React, { useState, useEffect } from 'react';
import { withSnackbar } from 'notistack';
import { Checkbox } from '@material-ui/core';

import { ScreenTitle, Question } from '../../../../components';
import LoadingModal from '../../../../components/atoms/LoadingModal';
import MessageModal from '../../../../components/molecules/MessageModal';
import Summary from '../Summary';
import ChallengeModal from '../challengeModal';
import './style.scss';

import {
  OFFLINE_USER,
  Strings,
  UNATTEMPTED_QUESTIONS_STATUS,
  ATTEMPTED_QUESTIONS_STATUS,
  MARKED_FOR_REVIEW_QUESTIONS,
  MARKED_FOR_REVIEW_QUESTIONS_STATUS,
  SIMULATED_TEST_TITLE,
  INITIAL_TEST,
  LIST_PAGE,
  SUBMIT_PAGE,
  SIMULATED_TEST_COMPLETED,
  QUESTION_MODAL,
} from '../../../../shared/constants/Constants';
import {
  achievement_6_details_less_75,
  achievement_6_details_more_75,
  achievementName_6,
  achievement_7_details,
  achievementName_7,
} from '../../../../shared/constants/AchievementConstants';
import Timer from '../../../../components/atoms/Timer';

import { checkOffline } from '../../../../shared/services/Utility';
import { Prompt } from 'react-router-dom';
import { ROUTE_CONSTANTS } from '../../../../shared/constants/Route';

let questionDetails = {};
let achievementName = '';
const SimulatedQuestions = ({
  state,
  loading,
  sessionToken,
  userId,
  history,
  gotoSimulatedTest,
  enqueueSnackbar,
  updateChallengeStatus = () => {
  },
  submit_simulated_test_scores = () => {
  },
  submit_challenge_complete_results = () => {
  },
  submit_challenge_request = () => {
  },
  save_accepted_challenge_data = () => {
  },
  submit_unlocked_achievement = () => {
  },
  achievement_unlocked = () => {
  },
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [titleText, setTitleText] = useState(SIMULATED_TEST_TITLE);
  const [currentView, setCurrentView] = useState(INITIAL_TEST);
  const [renderQuestionListType, setRenderQuestionListType] = useState(0);
  // const [attemptedQuestionCount, setAttemptedQuestionCount] = useState(0);
  // const [finalTestScrore, setFinalTestScrore] = useState(0);
  const [timeEnd, setTimeEnd] = useState(false);
  const [timeEndModal, set_timeEndModal] = useState(false);
  const [isTestRunning, setIsTestRunning] = useState(true);
  const [buttonEnabled, setButtonEnabled] = useState(false);
  const [showAchievementModal, setShowAchievementModal] = useState(false);
  // const [allQuestionViewed, setAllQuestionViewed] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [selectedItem, setSelectedItem] = useState(-1);
  const [currentReviewIndex, setCurrentReviewIndex] = useState(-1);
  // const [questionsDetailArray, setQuestionsDetailArray] = useState([]);

  const [opponent_data, setOpponent_data] = useState({
    opponent_userId: 0,
    challenge_id: 0,
    opponents_scores: 0,
  });

  // modal usestate
  const [summaryState, setSummary] = useState(false);
  const [challengeState, setChallenge] = useState(false);
  const [modalState, setModal] = useState(false);
  const [unmountModal, setUnmount] = useState(false);
  const [message, setMessage] = useState('');

  const TestQuesData = [
    ['Federal Mortgage Related Laws'],
    ['General Mortgage Knowledge'],
    ['Mortgage Loan Origination Activities'],
    ['Ethics Loan Origination Activities'],
    ['Uniform State Content'],
  ];

  const [showQuestionModal, setShowQuestionModal] = useState(false);
  const [allData, set_allData] = useState([]);
  const [companyData, set_companyData] = useState([]);
  const [username, set_username] = useState('');
  const [company, set_company] = useState('');
  const [user_id, set_user_id] = useState('');
  const [achievementDetailsText, setAchievementDetailsText] = useState('');
  const [reviewNum, set_reviewNum] = useState(0);

  let answer = '';
  let correctAnswer = '';

  let finalTestScores = -1;
  let optionsArray = [];
  let answeredQuestionsArray = [0, 0, 0, 0, 0];
  let correctQuestionsArray = [0, 0, 0, 0, 0];
  let TestResult = [0, 0, 0, 0, 0];
  let testResponseBody = {};

  // / unmount  / ------> next case
  // useEffect(() => {
  //   return(()=>{
  //     setUnmount(true);
  //     setMessage("Do you really want to quit?");
  //   })
  // }, []);

  /***********Prompt user  *******/
  const [preventUser, set_preventUser] = useState(true);
  useEffect(() => {
    if (preventUser) {
      window.onbeforeunload = () => true;
    } else {
      window.onbeforeunload = undefined;
    }
    return () => {
      set_preventUser(false);
      window.onbeforeunload = undefined;
    };
  }, [preventUser]);
  /******************************/

  useEffect(() => {
    // const filter = state.SimulatedTestReducer.questionList.filter(
    //   (question) => question.question_type !== "0"
    // );
  }, [state.SimulatedTestReducer.questionList]);

  useEffect(() => {
    if (state.SimulatedTestReducer.questionList.length <= 0) {
      const questionBody = {
        userId,
        sessionToken,
      };
      gotoSimulatedTest(questionBody, (message, type) => {
        if (type !== 'success') {
          enqueueSnackbar(message, {
            variant: type,
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
          });
        }
      });
    } else {
      state.SimulatedTestReducer.questionList.map((question, index) => {
        return (
          (question.question_status = UNATTEMPTED_QUESTIONS_STATUS),
            (question.qNumber = index),
            (question.correct_incorrect_status = 0)
        );
      });
      //
    }
    /* is challenge accepted */
    if (state.ChallengeReducer.acceptChallengeData.length > 0) {
      const {
        opponents_scores,
        opponent_userId,
        challenge_id,
      } = state.ChallengeReducer.acceptChallengeData[0];
      setOpponent_data({
        opponents_scores,
        opponent_userId,
        challenge_id,
      });
      // opponent_data.opponents_scores =
      //   state.ChallengeReducer.acceptChallengeData.opponents_scores;
      // opponent_data.opponent_userId =
      //   state.ChallengeReducer.acceptChallengeData.opponent_userId;
      // opponent_data.challenge_id =
      //   state.ChallengeReducer.acceptChallengeData.challenge_id;

      /* empty the reducer */
      // state.ChallengeReducer.acceptChallengeData = [];
    }
  }, []);

  const set_correct_incorrect_status = (status, reviewIndex = '') => {
    if (reviewIndex !== '') {
      state.SimulatedTestReducer.questionList[
        reviewIndex
        ].correct_incorrect_status = status;
    } else if (reviewIndex === 0) {
      state.SimulatedTestReducer.questionList[
        reviewIndex
        ].correct_incorrect_status = status;
    } else {
      state.SimulatedTestReducer.questionList[
        currentIndex
        ].correct_incorrect_status = status;
    }
  };

  const checkIfCorrectorIncorrect = (questionData, reviewindex = '') => {
    optionsArray = [
      questionData.ans1,
      questionData.ans2,
      questionData.ans3,
      questionData.ans4,
    ];

    let result = Strings.INCORRECT_ANSWER;

    if (questionData.question_type !== '2') {
      if (correctAnswer.trim() === optionsArray[selectedItem].trim()) {
        result = Strings.CORRECT_ANSWER;
      }
    } else {
      if (
        JSON.stringify(questionData.matchup_answers) === JSON.stringify(answer)
      ) {
        result = Strings.CORRECT_ANSWER;
      }
    }

    set_correct_incorrect_status(
      result === Strings.INCORRECT_ANSWER ? 0 : 1,
      reviewindex,
    );
  };

  const checkIfQuestionAttempted = () => {
    if (
      selectedItem !== -1 &&
      selectedItem !== undefined &&
      selectedItem !== null
    ) {
      state.SimulatedTestReducer.questionList[
        currentIndex
        ].question_status = isChecked
        ? MARKED_FOR_REVIEW_QUESTIONS_STATUS
        : ATTEMPTED_QUESTIONS_STATUS;
      state.SimulatedTestReducer.questionList[currentIndex].previousAnswer =
        selectedItem !== -1 ? selectedItem : answer;
    } else if (isChecked) {
      state.SimulatedTestReducer.questionList[
        currentIndex
        ].question_status = MARKED_FOR_REVIEW_QUESTIONS_STATUS;
    } else {
      state.SimulatedTestReducer.questionList[
        currentIndex
        ].question_status = UNATTEMPTED_QUESTIONS_STATUS;
    }
    checkIfCorrectorIncorrect(
      state.SimulatedTestReducer.questionList[currentIndex],
    );
  };

  const resetOldState = () => {
    setButtonEnabled(false);
    setSelectedItem(-1);
  };

  const getScreenTitleForQuestionList = (listType, type) => {
    setTitleText(listType);
    setCurrentView(LIST_PAGE);
    setRenderQuestionListType(type);
  };

  const createFinalDataArrays = (index, start, end) => {
    let correctAnswersInCategory = 0,
      answeredQuestionsInCategory = 0;
    for (let k = start; k < end; k++) {
      let element = state.SimulatedTestReducer.questionList[k];

      if (element.correct_incorrect_status === 1) {
        correctAnswersInCategory++;
      }
      if (
        element.question_status === ATTEMPTED_QUESTIONS_STATUS ||
        element.question_status === MARKED_FOR_REVIEW_QUESTIONS_STATUS
      ) {
        answeredQuestionsInCategory++;
      }
    }
    answeredQuestionsArray[index] = answeredQuestionsInCategory;
    correctQuestionsArray[index] = correctAnswersInCategory;
    TestResult[index] =
      state.SimulatedTestReducer.questionList.length === 0
        ? 0
        : correctAnswersInCategory /
        state.SimulatedTestReducer.questionList.length;
    TestResult[index] *= 100;
  };

  const onSubmitdata = () => {
    // create data json /
    let totalQuestionsArray = [
      state.SimulatedTestReducer.numberOfQuestionsList.catID_1,
      state.SimulatedTestReducer.numberOfQuestionsList.catID_3,
      state.SimulatedTestReducer.numberOfQuestionsList.catID_5,
      state.SimulatedTestReducer.numberOfQuestionsList.catID_6,
      state.SimulatedTestReducer.numberOfQuestionsList.catID_7,
    ];
    let topicID = [1, 3, 5, 6, 7];

    let start = 0,
      end = 0;
    for (let i = 0; i < totalQuestionsArray.length; i++) {
      end = 0;
      for (let j = 0; j <= i; j++) {
        end += totalQuestionsArray[j];
      }

      start = end - totalQuestionsArray[i];

      createFinalDataArrays(i, start, end);
    }
    let categoryArray = [];
    totalQuestionsArray.forEach((item, index) => {
      categoryArray.push({
        category_id: topicID[index],
        total_question: item,
        answered_question: answeredQuestionsArray[index],
        correct_answer: correctQuestionsArray[index],
      });
      TestResult[index] =
        (parseInt(correctQuestionsArray[index]) * 100) / parseInt(item);
    });
    // alert(Object.keys(this.props.state.SimulatedTestReducer.numberOfQuestionsList))
    testResponseBody = {
      category_id: 1,
      userId,
      sessionToken,
      categoryArray,
    };

    // this.submit_final_test_results(testResponseBody)

    // this.state.tableData = [
    //   ['', ''],
    //   ['Federal Mortgage Related Laws\n', ((this.TestResult[0]).toFixed(2)).toString() + '%\n'],
    //   ['General Mortgage Knowledge\n', ((this.TestResult[1]).toFixed(2)).toString() + '%\n'],
    //   ['Mortgage Loan Origination Activities\n', ((this.TestResult[2]).toFixed(2)).toString() + '%\n'],
    //   ['Ethics\n', ((this.TestResult[3]).toFixed(2)).toString() + '%\n'],
    //   ['Uniform State Content', ((this.TestResult[4]).toFixed(2)).toString() + '%'],
    // ]
  };

  const showSubmitView = () => {
    onSubmitdata();
    setIsTestRunning(false);
    setTitleText(SIMULATED_TEST_COMPLETED);
    setCurrentView(SUBMIT_PAGE);
  };

  const goForward = () => {
    checkIfQuestionAttempted();
    if (currentIndex < state.SimulatedTestReducer.questionList.length - 1) {
      // LayoutAnimation.configureNext(LayoutAnimation.Presets.spring);
      // oneTimeProcessForNewQuestion(currentIndex + 1);

      setCurrentIndex((prevState) => prevState + 1);
      setIsChecked(false);

      resetOldState();
    } else {
      setSelectedItem(-1);
      let markedQuestionCount = 0;
      state.SimulatedTestReducer.questionList.forEach((itm) => {
        if (itm.question_status === MARKED_FOR_REVIEW_QUESTIONS_STATUS) {
          markedQuestionCount++;
        }
      });
      if (markedQuestionCount > 0) {
        setIsTestRunning(false);
        // setTimeout(() => {
        //   setIsTestRunning(false);
        // }, 1000);
        getScreenTitleForQuestionList(
          MARKED_FOR_REVIEW_QUESTIONS,
          MARKED_FOR_REVIEW_QUESTIONS_STATUS,
        );
        // gotoQuestionListScreen();
      } else {
        checkAchievement();
        showSubmitView();
      }
      setTimeout(() => {
        setButtonEnabled(true);
      }, 1500);
    }
    questionDetails = state.SimulatedTestReducer.questionList[currentIndex];
  };

  const selectAnswer = (selectedAnswer) => {
    setSelectedItem(selectedAnswer);
    setButtonEnabled(true);
  };

  const handleChecked = () => {
    setIsChecked((prevState) => !prevState);
  };

  const renderQuestionConatiner = (questionData) => {
    questionDetails = questionData;
    questionDetails.question_number = currentIndex;
    correctAnswer = questionData.correctAnswer;

    return (
      <>
        <div className='question-container'>
          <Question
            question={questionData.question}
            options={[
              questionData.ans1,
              questionData.ans2,
              questionData.ans3,
              questionData.ans4,
            ]}
            questionNumber={currentIndex + 1}
            selectedAnswer={selectedItem}
            selectAnswer={selectAnswer}
          />
        </div>
        <div className='checkbox-container'>
          <Checkbox
            onChange={handleChecked}
            checked={isChecked}
            color='default'
          />
          <p>{Strings.markForReview}</p>
        </div>
        <button
          className={`start-cards-btn mt-3 ml-0 ${
            buttonEnabled ? '' : 'disabled-btn'
          }`}
          disabled={!buttonEnabled}
          onClick={goForward}
        >
          Submit Answer
        </button>
      </>
    );
  };

  const submit_final_test_results = (testResponseBody) => {
    /****************allow user to leave page  **********/
    set_preventUser(false);
    /***************************************************/
    /* submit challenge complete status */
    if (opponent_data.opponents_scores > 0) {
      const history_data = {
        userId: userId,
        sessionToken: sessionToken,
        challenge_ID: opponent_data.challenge_id,
        accept_score: finalTestScores,
        challenge_from: opponent_data.opponent_userId,
        challenge_score: opponent_data.opponents_scores,
      };
      submit_challenge_complete_results(history_data, (message, type) => {
        if (type !== 'success') {
          enqueueSnackbar(message, {
            variant: type,
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
          });
        }
      });
      submit_simulated_test_scores(
        testResponseBody,
        {
          userId: userId,
          sessionToken: sessionToken,
        },
        () => {
          updateChallengeStatus(false);
          save_accepted_challenge_data(null);
          // state.ChallengeReducer.acceptChallengeData = [];
          setMessage(
            'Simulated test successfully submitted. Challenge successfully completed.',
          );
          setModal(true);
        },
        (message, type) => {
          if (type !== 'success') {
            enqueueSnackbar(message, {
              variant: type,
              autoHideDuration: 3000,
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
              },
            });
          }
        },
      );

      // Alert.alert(APP_NAME, "Challenge successfully completed.", [
      //   {
      //     text: OK,
      //     onPress: () => {
      //       this.props.submit_simulated_test_scores(testResponseBody, {
      //         userId: this.props.userId,
      //         sessionToken: this.props.sessionToken
      //       });
      //     }
      //   }
      // ]);
    } else {
      submit_simulated_test_scores(
        testResponseBody,
        {
          userId: userId,
          sessionToken: sessionToken,
        },
        () => {
          setMessage('Simulated test successfully submitted.');
          setModal(true);
        },
        (message, type) => {
          if (type !== 'success') {
            enqueueSnackbar(message, {
              variant: type,
              autoHideDuration: 3000,
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
              },
            });
          }
        },
      );
    }
  };

  /**
   * back button while test is going on
   */
  const onPressSubmitBtn = (val) => {
    if (checkOffline()) {
      enqueueSnackbar(OFFLINE_USER, {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left',
        },
      });
    } else {
      if (val === true) {
        // this.onSubmitData()

        ////   ------ imppppppp
        submit_final_test_results(testResponseBody);
      } else {
        // Alert.alert(APP_NAME, "Do you really want to quit?", [
        //   {
        //     text: CANCEL,
        //     onPress: () => { }
        //   },
        //   {
        //     text: OK,
        //     onPress: () => {
        //       this.props.back_from_simulated_test();
        //     }
        //   }
        // ]);
      }
    }
  };

  useEffect(() => {
  }, [showAchievementModal]);

  // Test complete ui
  const renderTestCompleteContainer = () => {
    onSubmitdata();
    let total = 0;
    TestResult.forEach((item) => (total += item));
    let total_correct = 0;
    correctQuestionsArray.forEach((itm) => (total_correct += parseInt(itm)));

    let total_answered = 0;
    answeredQuestionsArray.forEach((itm) => (total_answered += parseInt(itm)));

    /* first test achievement */

    // if (!state.CommonReducer.firstSimulatedTest) {
    //   if ((total_correct / total_answered) * 100 < 75.0) {
    //     achievementDetailsText = achievement_6_details_less_75;
    //   } else {
    //     achievementDetailsText = achievement_6_details_more_75;
    //   }
    //   achievementName = achievementName_6;
    //
    //   setShowAchievementModal(true);
    //   state.CommonReducer.firstSimulatedTest = true;

    //   // state.CommonReducer.unlockedAchievementArray[5] = true;
    // }

    /* second test achievement */
    // if (
    //   state.CommonReducer.firstSimulatedTest &&
    //   !state.CommonReducer.secondSimulatedTest
    // ) {
    //   achievementDetailsText = achievement_7_details;
    //   achievementName = achievementName_7;
    //   state.CommonReducer.secondSimulatedTest = true;
    //   // showAchievementModal();

    //   state.CommonReducer.unlockedAchievementArray[6] = true;
    // }

    /* save test results for API */
    finalTestScores = parseInt((total_correct / total_answered) * 100);

    return (
      renderQuestionListType === 0 && (
        <>
          <div className='row'>
            <div className='col6'>
              <div className='result_area'>
                <div className='result_section'>
                  <h5>
                    T E S T<span>R E S U L T</span>
                  </h5>
                  <div className='result_list'>
                    <ul>
                      <li>
                        <span className='result_title'>TOPIC</span>
                        <span className='result_title'>Result</span>
                      </li>
                      {TestQuesData.map((rowData, index) => (
                        <li key={index}>
                          <span> {[rowData[0]]}</span>
                          <span>
                            {answeredQuestionsArray[index] === 0
                              ? '0%'
                              : parseInt(
                              (correctQuestionsArray[index] /
                                answeredQuestionsArray[index]) *
                              100,
                            ) + '%'}
                          </span>
                        </li>
                      ))}

                      <li>
                        <span className='f_title'>Total</span>
                        <span className='f_title'>
                          {total_answered !== 0
                            ? parseInt((total_correct / total_answered) * 100) +
                            '%'
                            : '0%'}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {opponent_data.opponents_scores > 0 ? (
            <div className='btn_wrap'>
              <div className='col12 test_result_btns'>
                <button
                  onClick={() => {
                    onPressSubmitBtn(true);
                  }}
                  className='blue-btn'
                  type='button'
                >
                  Submit
                </button>
              </div>
            </div>
          ) : (
            <div className='btn_wrap'>
              <div className='col12 test_result_btns'>
                <button
                  onClick={onChallangeBtnClick}
                  className='blue-btn'
                  type='button'
                >
                  Challenge{' '}
                </button>

                <button
                  onClick={() => {
                    setSummary(true);
                  }}
                  className='blue-btn'
                  type='button'
                >
                  Test summary
                </button>

                <button
                  onClick={() => {
                    onPressSubmitBtn(true);
                  }}
                  className='blue-btn'
                  type='button'
                >
                  Submit
                </button>
              </div>
            </div>
          )}
        </>
      )
    );
  };

  /**** on challenge button click ****/

  const onChallangeBtnClick = () => {
    setChallenge(true);
    if (state.DashBoardReducer.challengeSendData.length > 0) {
      /* update data to be shown in challenge screen */
      set_allData(state.DashBoardReducer.challengeSendData);

      /* update userdata */
      let companyName = '';
      state.DashBoardReducer.challengeSendData.forEach((data, index) => {
        if (data.userId === state.CommonReducer.userId) {
          companyName = data.companyName;
          set_username(data.userName);
          set_company(data.companyName);
          set_user_id(data.userId);
        }
      });

      /* filter leaderboard data company wise */
      let data = state.DashBoardReducer.challengeSendData.filter(
        (val) => val.companyName === companyName,
      );
      set_companyData(data);
    }
  };

  /**** send challenge to *****/
  const onChallengeSentTo = (opponent_userId) => {
    const challengeRequestBody = {
      userId: state.CommonReducer.userId,
      sessionToken: state.CommonReducer.sessionToken,
      challenge_to: opponent_userId,
      test_score: finalTestScores,
    };

    submit_challenge_request(challengeRequestBody, (message, type) => {
      enqueueSnackbar(message, {
        variant: type,
        autoHideDuration: 3000,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left',
        },
      });
    });
    setChallenge(false);
  };

  /**** update reviewed answer *****/

  const selectReviewAnswer = (ans) => {
    setSelectedItem(ans);
    state.SimulatedTestReducer.questionList[
      currentReviewIndex
      ].previousAnswer = ans;
  };

  /*** render review questions ****/

  const renderQuestionModal = () => {
    let questionData =
      state.SimulatedTestReducer.questionList[currentReviewIndex];
    if (selectedItem === -1) {
      setSelectedItem(
        state.SimulatedTestReducer.questionList[currentReviewIndex].previousAnswer,
      );
    }
    correctAnswer = questionData.correctAnswer;
    /***callback ****/
    // const Summary = ({ callback = () => {}, questionList }) => {

    return (
      <div class='modal fade model_summ result_review'>
        <div className='modal-overlay'></div>
        <div class='modal-dialog model-lg '>
          <div class='modal-content'>
            <div class='modal-header'>
              <div
                className='review-question-modal-cancel-btn-container'
                onClick={() => {
                  setSelectedItem(-1);
                  setShowQuestionModal(false);
                }}
              >
                <i className='clos_btn'>
                  <img
                    src={require('../../../../Assets/Images/Icons/close_icon.png')}
                    alt='close'
                  />
                </i>
              </div>
            </div>
            <div class='modal-body'>
              <div className='simulated_results'>
                <div className='card_det'>
                  <Question
                    value={true}
                    question={questionData.question}
                    options={[
                      questionData.ans1,
                      questionData.ans2,
                      questionData.ans3,
                      questionData.ans4,
                    ]}
                    questionNumber={reviewNum}
                    selectedAnswer={selectedItem}
                    selectAnswer={selectReviewAnswer}
                  />
                  <button
                    className={`start-cards-btn mt-3 ml-0 ${
                      buttonEnabled ? '' : 'disabled-btn'
                    }`}
                    disabled={!buttonEnabled}
                    onClick={() => {
                      state.SimulatedTestReducer.questionList[
                        currentReviewIndex
                        ].question_status = ATTEMPTED_QUESTIONS_STATUS;
                      checkIfCorrectorIncorrect(
                        state.SimulatedTestReducer.questionList[
                          currentReviewIndex
                          ],
                        currentReviewIndex,
                      );
                      // setShowQuestionModal(false);
                      setSelectedItem(-1);
                      goToNextMarkedQuestion();
                    }}
                  >
                    Submit Answer
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      // <div className="modal model-lg">
      //   <div className="modal-overlay"></div>

      //   <div
      //     className="modal-body question-modal-body"
      //     style={{ backgroundColor: "#fff" }}
      //   >
      //     <div className="modal-header">

      //     </div>

      //   </div>
      // </div>
    );
  };

  const styless = {
    cancelBtnWrapper: {
      position: 'absolute',
      right: 15,
      top: 15,
      bottom: 0,
    },
    cancelIcon: {
      color: '#fff',
      fontSize: 30,
    },
  };

  /*** go to next review Question  ****/

  const goToNextMarkedQuestion = () => {
    for (
      let i = currentReviewIndex + 1;
      i < state.SimulatedTestReducer.questionList.length;
      i++
    ) {
      if (
        state.SimulatedTestReducer.questionList[i].question_status ===
        MARKED_FOR_REVIEW_QUESTIONS_STATUS
      ) {
        set_reviewNum(reviewNum + 1);
        setCurrentReviewIndex(i);
        return;
      }
    }
    if (
      !state.SimulatedTestReducer.questionList.find(
        (itm) => itm.question_status === MARKED_FOR_REVIEW_QUESTIONS_STATUS,
      )
    ) {
      submitReviewedQuestions();
    }
    set_reviewNum(0);
    setShowQuestionModal(false);
  };

  const checkAchievement = () => {
    onSubmitdata();
    let total = 0;
    TestResult.forEach((item) => (total += item));

    let total_correct = 0;
    correctQuestionsArray.forEach((itm) => (total_correct += parseInt(itm)));

    let total_answered = 0;
    answeredQuestionsArray.forEach((itm) => (total_answered += parseInt(itm)));

    if (!state.CommonReducer.firstSimulatedTest) {
      if ((total_correct / total_answered) * 100 < 75.0) {
        setAchievementDetailsText(achievement_6_details_less_75);
      } else {
        setAchievementDetailsText(achievement_6_details_more_75);
      }
      achievementName = achievementName_6;
      setShowAchievementModal(true);
      achievement_unlocked('firstSimulatedTest', true);
      // state.CommonReducer.firstSimulatedTest = true;

      state.CommonReducer.unlockedAchievementArray[5] = true;
    } else if (!state.CommonReducer.secondSimulatedTest) {
      /* second test achievement */
      setAchievementDetailsText(achievement_7_details);
      achievementName = achievementName_7;
      setShowAchievementModal(true);
      achievement_unlocked('secondSimulatedTest', true);
      //state.CommonReducer.secondSimulatedTest = true;
      state.CommonReducer.unlockedAchievementArray[6] = true;
    }
  };

  /***Submit reviewed questions ****/

  const submitReviewedQuestions = () => {
    /* animate current page */
    setCurrentView(SUBMIT_PAGE);
    setTitleText(SIMULATED_TEST_COMPLETED);
    state.SimulatedTestReducer.questionList.forEach((itm, ind) => {
      if (itm.question_status === MARKED_FOR_REVIEW_QUESTIONS_STATUS) {
        state.SimulatedTestReducer.questionList[
          ind
          ].question_status = ATTEMPTED_QUESTIONS_STATUS;
      }
    });
    checkAchievement();
    setRenderQuestionListType(0);
    showSubmitView();
  };

  /* render question list */

  const renderQuestionList = (questionList, listType) => {
    let ind = [];
    let p;
    return !showQuestionModal ? (
      <>
        <div
          className='simulated_results review_block'
          style={{}}
        >
          <div className='btn_wrap summery_btn'>
            <button className='blue-btn pull-right w-100' type='button'>
              Review Questions
            </button>
          </div>
          <div className='card_det'>
            {questionList.map((question, index) => {
              if (question.question_status === listType) {
                let currentItem = index;
                let que = question.question.split(Strings.FILLUP_TAG).join('___');
                ind.push(index);
                return (
                  <div
                    key={index}
                    className={'review-question'}
                    onClick={() => {
                      p = ind.findIndex((e) => e === currentItem);
                      set_reviewNum(p + 1);
                      setCurrentView(QUESTION_MODAL);
                      setCurrentReviewIndex(currentItem);
                      setShowQuestionModal(true);
                    }}
                  >
                    <p className='m-0'>{que}</p>
                  </div>
                );
              }
            })}
          </div>
        </div>
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <button
            className='start-cards-btn mt-1 pull-right'
            style={{ display: 'initial' }}
            type='button'
            onClick={() => {
              submitReviewedQuestions();
            }}
          >
            {'Submit'}
          </button>
        </div>
      </>
    ) : null;
    // </Animated.View>
  };

  // const unLoadQuestionModal = () => {
  //   setShowQuestionModal(false), setCurrentView(LIST_PAGE);
  // };

  const hideAchievementModal = () => {
    setShowAchievementModal(false);
    if (achievementName) {
      submit_unlocked_achievement({
        userId,
        sessionToken,
        achievement_type: achievementName,
      });
    }
    setAchievementDetailsText('');
    achievementName = '';
  };

  /********** end test when time is zero  ********/
  const endTest = () => {
    setMessage('Test time is up.');
    setTimeEnd(true);
    set_timeEndModal(true);
  };
  /*********************************************/

  return (
    <>
      <Prompt
        when={preventUser}
        message={() => `Are you sure you want to quit?`}
      />
      {showAchievementModal && (
        <MessageModal
          icon='trophy.png'
          title='Achievement Unlocked!'
          message={achievementDetailsText}
          color={'#fff'}
          callback={hideAchievementModal}
        />
      )}
      {unmountModal && (
        <MessageModal
          title='Prep2pass'
          message={message}
          color={'#fff'}
          callback={() => {
            setUnmount(false);
            setMessage('');
            // <Redirect to={ROUTE_CONSTANTS.SIMULATDED_TESTS} />
          }}
          render={() => {
            return (
              <>
                <button
                  style={{
                    background: '#fff',
                    border: '1.25px solid #7ebf41',
                    color: '#7ebf41',
                    padding: '.65rem 2rem',
                    borderRadius: '5px',
                    fontWeight: 'bolder',
                    margin: '1rem',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    history.replace(ROUTE_CONSTANTS.SIMULATDED_TESTS);
                  }}
                >
                  Okay
                </button>
                <button
                  style={{
                    background: '#fff',
                    border: '1.25px solid #777',
                    color: '#777',
                    padding: '.65rem 2rem',
                    borderRadius: '5px',
                    fontWeight: 'bolder',
                    margin: '1rem',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    setUnmount(false);
                    setMessage('');
                  }}
                >
                  Cancel
                </button>
              </>
            );
          }}
        />
      )}
      {modalState && (
        <MessageModal
          title='Prep2pass'
          message={message}
          color={'#fff'}
          callback={() => {
            setModal(false);
            setMessage('');
            // <Redirect to={ROUTE_CONSTANTS.SIMULATDED_TESTS} />
            history.replace(ROUTE_CONSTANTS.SIMULATDED_TESTS);
          }}
        />
      )}
      <ScreenTitle title={Strings.simulatedTest}/>
      {loading ? (
        <LoadingModal isVisible={loading}/>
      ) : (
        state.SimulatedTestReducer.questionList[currentIndex] && (
          <>
            {currentView !== SUBMIT_PAGE && (
              <Timer
                totalTime={
                  timeEnd
                    ? -1
                    : 1000 * 60 * parseInt(state.SimulatedTestReducer.testTime)
                }
                timerStart={currentView === SUBMIT_PAGE ? false : true}
                endTest={endTest}
              />
            )}
            {isTestRunning
              ? renderQuestionConatiner(
                state.SimulatedTestReducer.questionList[currentIndex],
              )
              : renderTestCompleteContainer()}
            {renderQuestionListType !== 0
              ? renderQuestionList(
                state.SimulatedTestReducer.questionList,
                renderQuestionListType,
              )
              : null}
            {showQuestionModal ? renderQuestionModal() : null}
          </>
        )
      )}

      {timeEndModal && (
        <MessageModal
          title='Prep2pass'
          message={message}
          color={'#fff'}
          callback={() => {
            set_timeEndModal(false);
            setMessage('');
            submitReviewedQuestions();
          }}
          render={() => {
            return (
              <>
                <button
                  style={{
                    background: '#fff',
                    border: '1.25px solid #7ebf41',
                    color: '#7ebf41',
                    padding: '.65rem 2rem',
                    borderRadius: '5px',
                    fontWeight: 'bolder',
                    margin: '1rem',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    set_timeEndModal(false);
                    setMessage('');
                    submitReviewedQuestions();
                  }}
                >
                  Okay
                </button>
              </>
            );
          }}
        />
      )}

      {summaryState && (
        <Summary
          callback={() => {
            setSummary(false);
          }}
          questionList={state.SimulatedTestReducer.questionList}
        />
      )}

      {challengeState && (
        <ChallengeModal
          allData={allData}
          companyData={companyData}
          userName={username}
          userid={user_id}
          challengeSentTo={onChallengeSentTo}
          callback={() => {
            setChallenge(false);
          }}
        />
      )}
    </>
  );
};

export default withSnackbar(SimulatedQuestions);
